import { Colors } from 'enums';
import { CSSObject, css } from 'styled-components';

const SCROLL_THUMB_WIDTH = 4;
const SCROLL_THUMB_PADDING = 6;

export const OBJECT_FOR_SCROLL_WITH_PADDING: CSSObject = {
  scrollBehavior: 'smooth',
  '::-webkit-scrollbar': {
    width: `${SCROLL_THUMB_WIDTH + SCROLL_THUMB_PADDING * 2}px`,
  },
  '::-webkit-scrollbar-thumb': {
    backgroundColor: Colors.yellow1,
    border: `${SCROLL_THUMB_PADDING}px solid transparent`,
    backgroundClip: 'content-box',
    borderRadius: '99px',
  },
  '::-webkit-scrollbar-track': {
    backgroundColor: Colors.white,
    borderRadius: '99px',
  },
  '::-webkit-scrollbar-thumb:hover': {
    backgroundColor: Colors.yellow2,
  },
};

export const CSS_FOR_SCROLL_WITH_PADDING = css(OBJECT_FOR_SCROLL_WITH_PADDING);
